"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.DragToScroll = void 0;
var _dragToScroll = require("./dragToScroll");
exports.PLUGIN_KEY = _dragToScroll.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _dragToScroll.PLUGIN_PRIORITY;
exports.DragToScroll = _dragToScroll.DragToScroll;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/dragToScroll/index.js
// module id = 1345
// module chunks = 0